<template>
  <section class="content">
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title pull-right">
              <button type="button" @click="newModal = true" class="btn primary-btn-my clear-new-modal">Add</button>
            </h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width: 10%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="Browser: activate to sort column ascending" style="width: 20%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Category Name
                      </th>
                       <th aria-label="Browser: activate to sort column ascending" style="width: 20%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Category description
                      </th>
                      <th style="width: 4%;" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
<!-- ================== New products model ================== -->
     <md-dialog :md-active.sync="newModal" class="model_show_catalog">
      <md-dialog-title class="model-title modal-width-100">Add new Category
        <a style="float: right;cursor: pointer;" class="md-primary" @click="newModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
       <form class="from_padding_catalog modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassNewForm('name')">
                <label class="lable-fileds">Name</label>
                <md-input name="name" id="name" autocomplete="given-name" v-model="newForm.name" />
                <span class="md-error" v-if="!$v.newForm.name.required">The Name is required</span>
                <span class="md-error" v-if="$v.newForm.name.required && this.newFormBackendValidation.name.isError">{{this.newFormBackendValidation.name.errorMsg}}</span>
              </md-field>
            </div>
          </div>
           <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassNewForm('name')">
                <label class="lable-fileds">Description</label>
                <md-input name="description" id="description" autocomplete="given-name" v-model="newForm.description" />
                <span class="md-error" v-if="!$v.newForm.description.required">The description is required</span>
                <span class="md-error" v-if="$v.newForm.description.required && this.newFormBackendValidation.description.isError">{{this.newFormBackendValidation.description.errorMsg}}</span>
              </md-field>
            </div>
          </div>

         <div class="custom-modal-footer-spaces"></div>

         <div class="custom-modal-footer-container">
           <button type="button" @click="validateSubmission" class="btn primary-btn-my custom-modal-footer-items">
             Add Category
           </button>
           &nbsp;&nbsp;&nbsp;
           <sync-loader class="custom-modal-footer-items" :loading="newModalLoading" :color="newModalColor" :size="newModalSize" :width="newModalWidth" :margin="newModalMargin"></sync-loader>
         </div>

        </form>
    </md-dialog>

     <!-- ================== Edit Products model ================== -->
    <md-dialog :md-active.sync="editModal" class="model_show_catalog">
      <md-dialog-title class="model-title modal-width-100">Edit Category
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from_padding_catalog modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassEditForm('name')">
                <label class="lable-fileds">Name</label>
                <md-input name="name" id="name" autocomplete="given-name" v-model="editForm.name" />
                <span class="md-error" v-if="!$v.editForm.name.required">The Name is required</span>
                <span class="md-error" v-if="$v.editForm.name.required && this.editFormBackendValidation.name.isError">{{this.editFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassEditForm('description')">
                <label class="lable-fileds">Description</label>
                <md-input name="description" id="description" autocomplete="description" v-model="editForm.description"/>
                <span class="md-error" v-if="!$v.editForm.description.required">The Description is required</span>
                <span class="md-error" v-if="$v.editForm.description.required && this.editFormBackendValidation.description.isError">{{this.editFormBackendValidation.description.errorMsg}}</span>
              </md-field>
            </div>
          </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateSubmission" class="btn primary-btn-my custom-modal-footer-items">
              Update Category
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor" :size="editModalSize" :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>
  </section>

</template>

<script>
  import $ from 'jquery'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var SyncLoader = require('vue-spinner/src/SyncLoader')

  // vue validations
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import config from '../../../config'
  import Vue from 'vue'
  var moment = require('moment')
  import api from '../../../api'

export default {
    name: 'ProductView',
    components: {
      'SyncLoader': SyncLoader
    },
    mixins: [validationMixin],
    data() {
      return {
        datatable: null,
        StateList: [],
        CountryList: [],
        IndustriesList: [],
        IndustrySelected: [],
        emails: [],
        newForm: {
          name: null,
          description: null
        },
        editForm: {
          name: null,
          description: null
        },
        active: false,
        editModal: false,
        newModal: false,
        editModalColor: '#FECD2F',
        editModalSize: '10px',
        editModalLoading: false,
        editModalHeight: '35px',
        editModalWidth: '5px',
        editModalMargin: '2px',
        editModalRadius: '2px',
        newModalColor: '#FECD2F',
        newModalSize: '10px',
        newModalLoading: false,
        newModalHeight: '35px',
        newModalWidth: '5px',
        newModalMargin: '2px',
        newModalRadius: '2px',
        newFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          }
        },
        editFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          }
        }
      }
    },
    mounted() {
      var ref = this
      $('h3').on('click', 'button.clear-new-modal', function () {
        ref.clearNewForm()
      })
      // clear new modal
      this.$nextTick(() => {
        this.initDatatables()
        this.initJqueryMethods()
      })
    },

    validations: {
      newForm: {
        name: {
          required
        },
        description: {
          required
        }
      },
      editForm: {
        name: {
          required
        },
        description: {
          required
        }
      }
    },

    methods: {
      initDatatables() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.data.original.recordsTotal
            json.draw = json.data.original.draw
            json.recordsFiltered = json.data.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/catalog_category/datatable',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'data.original.data',
              headers: {
                'Authorization': 'Bearer ' + Vue.auth.getToken()
              }
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + moment(full.created_at).format('MM/DD/YYYY') + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.description + '</span>'
                }
              },
              {
                'orderable': false,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i>' +
                    '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>'
                }
              }
            ]
          })
      },

      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showEditModal(id)
        })
        // delete record
        $('#tableData tbody').on('click', 'td.details-control button.btn-delete', function () {
          var id = $(this).attr('data-id')
          ref.deleteNewRecord(id)
        })
      },

      clearNewForm() {
        this.$v.$reset()
        this.newForm.name = ''
        this.newForm.description = ''
      },

      addNewRecord(data) {
        console.log(data)
        this.newModalLoading = true
        var ref = this
        api.request('post', '/admin/catalog_category/create', data)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            this.form = response.data
            this.newModalLoading = false

            if (response.data.error) {
              $.each(response.data.error, function (key, valueObj) {
                if (ref.newFormBackendValidation.hasOwnProperty(key.toString())) {
                  ref.newFormBackendValidation[key.toString()].isError = true
                  ref.newFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                  $('#' + key.toString()).parent().addClass('md-invalid')
                }
              })
            } else if (response.data.status === 'success') {
              ref.newModal = false
              this.dataTable.ajax.reload(null, false)
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Record updated successfully'})
            }
          } else {
            this.editModalLoading = false
            // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: 'Something wrong'})
          }
        })
      },

      editNewRecord(data) {
        this.editModalLoading = true
        var ref = this
        api.request('post', '/admin/catalog_category/update/' + data.id, data)
          .then(response => {
            if (response.status === 200) {
              this.form = response.data
              this.editModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.editFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.editFormBackendValidation[key.toString()].isError = true
                    ref.editFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                  }
                })
              } else if (response.data.status === 'success') {
                ref.editModal = false
                this.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              }
            } else {
              this.editModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            this.editModalLoading = false
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },

      deleteNewRecord(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: 'If you delete this item, any products that are mapped will be deleted. Are you sure you want to proceed?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/catalog_category/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.data.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.dataTable.ajax.reload(null, false)
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      },

      showEditModal(id) {
        api.request('get', '/admin/catalog_category/show/' + id)
          .then(response => {
            if (response.status === 200) {
              this.editForm = response.data.data
              this.editModal = true
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },

      getValidationClassNewForm(fieldName) {
        const field = this.$v.newForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getValidationClassEditForm(fieldName) {
        const field = this.$v.editForm[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateSubmission() {
        this.$v.$touch()
        if (!this.$v.newForm.$invalid && this.newModal) {
          this.addNewRecord(this.$v.newForm.$model)
        }
        if (!this.$v.editForm.$invalid && this.editModal) {
          this.editNewRecord(this.$v.editForm.$model)
        }
      }

    }
  }
</script>

<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// ProductCatalogCategory.vue?517ef5ba